/*
 * The runtime of the lean signed-out layout (views/support/layouts/
 * register_lean.php): shows the messages the server left for the page
 * (support/partials/notices_lean prints them as JSON). The old layout did
 * this with jQuery and append_notification().
 */
import { notify } from '@admin/helpers.js';

function showNotices() {
    const notices = document.getElementById('admin-notices');
    if (!notices) return;

    try {
        JSON.parse(notices.textContent || '[]').forEach((notice) => notify(notice.type, notice.message));
    } catch (e) {
        // Nothing to show
    }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showNotices);
else showNotices();
